import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = { class: "display-4" }
const _hoisted_4 = { class: "lead" }
const _hoisted_5 = { class: "table table-sm" }
const _hoisted_6 = { class: "form-check form-check-inline" }
const _hoisted_7 = ["id", "name", "value"]
const _hoisted_8 = ["for"]
const _hoisted_9 = {
  "data-toggle": "collapse",
  href: "#groupsCollapse",
  role: "button"
}
const _hoisted_10 = {
  "data-toggle": "collapse",
  href: "#emailsCollapse",
  role: "button"
}
const _hoisted_11 = {
  class: "collapse",
  id: "groupsCollapse"
}
const _hoisted_12 = { class: "card card-body" }
const _hoisted_13 = ["id", "value"]
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  class: "collapse",
  id: "emailsCollapse"
}
const _hoisted_16 = { class: "card card-body" }
const _hoisted_17 = ["id", "value"]
const _hoisted_18 = {
  key: 0,
  class: "fa fa-user text-success",
  title: "User"
}
const _hoisted_19 = {
  key: 1,
  class: "fa-regular fa-user text-secondary",
  title: "Not an user"
}
const _hoisted_20 = ["for", "value"]
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 0,
  class: "col-sm-4"
}
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = ["id", "value"]
const _hoisted_25 = ["for"]
const _hoisted_26 = {
  key: 1,
  class: "col-sm-4"
}
const _hoisted_27 = { class: "form-check" }
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "col-sm-4" }
const _hoisted_31 = { class: "form-check" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["href"]
const _hoisted_34 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_35 = ["href"]

import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useSharePage } from '@DataSharing/Shares/pages-core'
    import ValidationError from "@common/Components/ValidationError.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SharePage',
  setup(__props) {

    document.title = 'Share data'

    const route = useRoute()
    const provider = route.params.provider
    const resourceId = route.params.resourceId
    const shareId = route.params.shareId

    const organizationUnitId = ref()
    const workspaceId = ref()
    const projectId = ref()
    const userId = ref()
    const sharedAt = ref(null)
    const sharedFor = ref()
    const sharedWith = ref()
    const resourceProviderName = ref(provider)
    const emailsProviderName = ref()
    const emailsProviderGroups = ref()
    const emailsProviderConfig = computed(() => emailsProviderGroups.value ? JSON.stringify(emailsProviderGroups.value) : null)
    const exists = ref()
    const isPaused = ref()

    const {
        useDataShareEmailsProvidersQuery, useShareQuery, useEmailsAndGroupsQuery,
        useShareDataCommand, useDeleteShareCommand, usePauseSharingCommand, useResumeSharingCommand
    } = useSharePage()

    const { modelShareQueryV1, runShareQueryV1 } = useShareQuery(resourceProviderName, resourceId, shareId)

    const { modelDataShareEmailsProvidersQueryV1, runDataShareEmailsProvidersQueryV1 } = useDataShareEmailsProvidersQuery(organizationUnitId, workspaceId, projectId)

    const { modelEmailsAndGroupsQueryV1, runEmailsAndGroupsQueryV1 } = useEmailsAndGroupsQuery(organizationUnitId, workspaceId, projectId, emailsProviderName)

    const { invokeShareDataCommandV1, succeedShareDataCommandV1, validationErrors } = useShareDataCommand(
        shareId, organizationUnitId, workspaceId, userId, sharedAt, sharedFor, sharedWith,
        resourceProviderName, resourceId, emailsProviderName, emailsProviderConfig)

    const { invokeDeleteShareCommandV1, succeedDeleteShareCommandV1 } = useDeleteShareCommand(shareId, userId)
    const { invokePauseSharingCommandV1, succeedPauseSharingCommandV1 } = usePauseSharingCommand(shareId)
    const { invokeResumeSharingCommandV1, succeedResumeSharingCommandV1 } = useResumeSharingCommand(shareId)

    function handleDeleteShareCommandV1() {
        if (confirm(`Do you want to delete this share?`)) {
            invokeDeleteShareCommandV1()
        }
    }

    const shares = computed(() => modelShareQueryV1.value?.Shares || [])
    const isShared = computed(() => modelShareQueryV1.value && shares.value.length > 0)
    const newShareId = computed(() => modelShareQueryV1.value?.NewShareId)
    const organizationName = computed(() => modelShareQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelShareQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelShareQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelShareQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelShareQueryV1.value?.ResourceUrl)
    const numberOfShares = computed(() => modelShareQueryV1.value?.NumberOfShares)
    const sharedForAvailableHours = computed(() => modelShareQueryV1.value?.SharedForAvailableHours)
    const sharedForAvailableDays = computed(() => modelShareQueryV1.value?.SharedForAvailableDays)
    const authenticatedUserRequired = computed(() => modelShareQueryV1.value?.AuthenticatedUserRequired)

    const emails = computed(() => modelEmailsAndGroupsQueryV1.value?.Emails || [])
    const groups = computed(() => modelEmailsAndGroupsQueryV1.value?.Groups || [])

    const dataShareEmailsProviders = computed(() => modelDataShareEmailsProvidersQueryV1.value?.Providers ?? [])
    const selectedEmailsProvider = computed(() => dataShareEmailsProviders.value.find(_ => _.Name == emailsProviderName.value))

    onMounted(() => runShareQueryV1())

    watch(modelShareQueryV1, () => {
        const model = modelShareQueryV1.value
        organizationUnitId.value = model?.OrganizationUnitId
        workspaceId.value = model?.WorkspaceId
        projectId.value = model?.ProjectId
        userId.value = model?.AuthenticatedUserId
        sharedFor.value = model?.SharedFor;
        emailsProviderName.value = model?.EmailsProviderName
        emailsProviderGroups.value = model?.EmailsProviderGroups || []
        exists.value = model?.Exists
        isPaused.value = model?.IsPaused
        runDataShareEmailsProvidersQueryV1()
    })

    watch(emailsProviderName, val => val ? runEmailsAndGroupsQueryV1() : null)

    watch(succeedShareDataCommandV1, navigateToShareNotificationPageIfSucceed)
    watch(succeedDeleteShareCommandV1, navigateToResourceSharePageIfSucceed)
    watch(succeedPauseSharingCommandV1, navigateToResourceSharePageIfSucceed)
    watch(succeedResumeSharingCommandV1, navigateToResourceSharePageIfSucceed)

    function navigateToResourceSharePageIfSucceed(succeed: boolean) {
        if (succeed) location.href = `/#/sharing/resource/${resourceProviderName.value}/${resourceId}`
    }

    function navigateToShareNotificationPageIfSucceed(succeed: boolean) {
        if (succeed) location.href = `/#/sharing/share/notification/${shareId}`
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, "Share " + _toDisplayString(resourceName.value), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, [
        _cache[9] || (_cache[9] = _createTextVNode("You are about to share ", -1 /* CACHED */)),
        _createElementVNode("strong", null, _toDisplayString(resourceName.value), 1 /* TEXT */),
        _cache[10] || (_cache[10] = _createTextVNode(" owned by ", -1 /* CACHED */)),
        _createElementVNode("strong", null, _toDisplayString(organizationName.value), 1 /* TEXT */),
        _cache[11] || (_cache[11] = _createTextVNode(" data in TransparentChoice application", -1 /* CACHED */))
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataShareEmailsProviders.value, (p) => {
              return (_openBlock(), _createElementBlock("th", {
                key: p.Name,
                scope: "col"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailsProviderName).value = $event)),
                    class: "form-check-input",
                    type: "radio",
                    id: p.Name,
                    name: p.Name,
                    value: p.Name
                  }, null, 8 /* PROPS */, _hoisted_7), [
                    [_vModelRadio, emailsProviderName.value]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: p.Name
                  }, _toDisplayString(p.Title), 9 /* TEXT, PROPS */, _hoisted_8)
                ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataShareEmailsProviders.value, (p) => {
              return (_openBlock(), _createElementBlock("td", {
                key: p.Name
              }, _toDisplayString(p.Description), 1 /* TEXT */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("a", _hoisted_9, "Select groups", 512 /* NEED_PATCH */), [
          [_vShow, groups.value.length>0]
        ]),
        _cache[12] || (_cache[12] = _createTextVNode("  ", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("a", _hoisted_10, "Select people", 512 /* NEED_PATCH */), [
          [_vShow, emails.value.length>0]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (g) => {
            return (_openBlock(), _createElementBlock("div", {
              key: g.Name,
              class: "form-check form-check-inline"
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailsProviderGroups).value = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: `g_${g.Name}`,
                value: g.Name
              }, null, 8 /* PROPS */, _hoisted_13), [
                [_vModelCheckbox, emailsProviderGroups.value]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `g_${g.Name}`
              }, _toDisplayString(g.Name), 9 /* TEXT, PROPS */, _hoisted_14)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emails.value, (e) => {
            return (_openBlock(), _createElementBlock("div", {
              key: e.Name,
              class: "form-check form-check-inline"
            }, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailsProviderGroups).value = $event)),
                class: "form-check-input",
                type: "checkbox",
                id: `e_${e.Name}`,
                value: e.Name
              }, null, 8 /* PROPS */, _hoisted_17), [
                [_vModelCheckbox, emailsProviderGroups.value]
              ]),
              (e.IsUser)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                : (_openBlock(), _createElementBlock("span", _hoisted_19)),
              _cache[13] || (_cache[13] = _createTextVNode("   ", -1 /* CACHED */)),
              _createElementVNode("label", {
                class: "form-check-label",
                for: `e_${e.Name}`,
                value: e
              }, _toDisplayString(e.Name), 9 /* TEXT, PROPS */, _hoisted_20)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createVNode(ValidationError, {
        context: "EmailsProviderName",
        errors: _unref(validationErrors)
      }, null, 8 /* PROPS */, ["errors"]),
      _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_21, [
        (sharedForAvailableHours.value && sharedForAvailableHours.value.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharedForAvailableHours.value, (v) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sharedFor).value = $event)),
                    class: "form-check-input",
                    type: "radio",
                    name: "sharedFor",
                    id: `sharedFor.${v.Value}`,
                    value: v.Value
                  }, null, 8 /* PROPS */, _hoisted_24), [
                    [_vModelRadio, sharedFor.value]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `sharedFor.${v.Value}`
                  }, "Share for " + _toDisplayString(v.Name), 9 /* TEXT, PROPS */, _hoisted_25)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        (sharedForAvailableDays.value && sharedForAvailableDays.value.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sharedForAvailableDays.value, (v) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sharedFor).value = $event)),
                    class: "form-check-input",
                    type: "radio",
                    name: "sharedFor",
                    id: `sharedFor.${v.Value}`,
                    value: v.Value
                  }, null, 8 /* PROPS */, _hoisted_28), [
                    [_vModelRadio, sharedFor.value]
                  ]),
                  _createElementVNode("label", {
                    class: "form-check-label",
                    for: `sharedFor.${v.Value}`
                  }, "Share for " + _toDisplayString(v.Name), 9 /* TEXT, PROPS */, _hoisted_29)
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((sharedFor).value = $event)),
              class: "form-check-input",
              type: "radio",
              name: "sharedFor",
              id: "sharedFor.forever",
              value: null
            }, null, 512 /* NEED_PATCH */), [
              [_vModelRadio, sharedFor.value]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("label", {
              class: "form-check-label",
              for: "sharedFor.forever"
            }, "Share forever", -1 /* CACHED */))
          ])
        ])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (numberOfShares.value>0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: `/#/sharing/resource/${_unref(provider)}/${_unref(resourceId)}`,
            class: "btn btn-lg btn-secondary m-1"
          }, "Back", 8 /* PROPS */, _hoisted_32))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: resourceUrl.value,
            class: "btn btn-lg btn-secondary m-1"
          }, "Back", 8 /* PROPS */, _hoisted_33)),
      (exists.value && !isPaused.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(invokePauseSharingCommandV1) && _unref(invokePauseSharingCommandV1)(...args))),
            class: "btn btn-lg btn-secondary m-1"
          }, "Pause sharing"))
        : _createCommentVNode("v-if", true),
      (exists.value && isPaused.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(invokeResumeSharingCommandV1) && _unref(invokeResumeSharingCommandV1)(...args))),
            class: "btn btn-lg btn-secondary m-1"
          }, "Resume sharing"))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(invokeShareDataCommandV1) && _unref(invokeShareDataCommandV1)(...args))),
        class: "btn btn-lg btn-primary pull-right m-1"
      }, "Share"),
      (exists.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            onClick: handleDeleteShareCommandV1,
            class: "btn btn-lg btn-danger pull-right m-1"
          }, "Delete share"))
        : _createCommentVNode("v-if", true),
      (authenticatedUserRequired.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("strong", null, " To share " + _toDisplayString(resourceName.value) + " the user must have Business User access to the software. ", 1 /* TEXT */),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("span", null, [
              _cache[15] || (_cache[15] = _createTextVNode(" This should be requested via the ", -1 /* CACHED */)),
              _createElementVNode("a", {
                href: `/#/pp/people/${workspaceId.value}/${projectId.value}`,
                target: "_blank"
              }, "People", 8 /* PROPS */, _hoisted_35),
              _cache[16] || (_cache[16] = _createTextVNode(" section & approved by your workspace admin to enable instant access to this project. ", -1 /* CACHED */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})